import {
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Component } from '@angular/core';
import { ParametriPasswords } from '../parametri-passwords';
import { AggiornaPasswordModel } from '../aggiorna-password-model';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import {
  DxButtonComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ildato-new-password',
  templateUrl: './ildato-new-password.component.html',
  styleUrls: ['./ildato-new-password.component.scss'],
  imports: [
    DxButtonComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
  ],
  standalone: true,
})
export class IlDatoNewPasswordComponent {
  @Input() username: string;
  @Input() parametriPasswords: ParametriPasswords;
  @Input() passwordObbligatoria: boolean;
  @Output() ilDatoNewPasswordEventEmitter =
    new EventEmitter<AggiornaPasswordModel>();

  newPassword: string = '';
  newPassword2: string = '';
  errMsg: string;
  authAvanzato: boolean = false;


  onBtnConfermaClick() {
    this.errMsg = null;
    this.authAvanzato = environment.authAvanzato;
    
    if (this.authAvanzato && this.passwordObbligatoria &&  !this.newPassword && !this.newPassword2){
      this.errMsg = 'Compilare almeno un campo tra Nome EntraID, Object ID e Password.';
      return;
    }

    if (this.passwordObbligatoria && (!this.newPassword || !this.newPassword2)) {
      this.errMsg = 'Inserire la nuovo password';
      return;
    }
  
    if (this.newPassword != this.newPassword2) {
      this.errMsg = 'Verifica nuova password: le 2 password non coincidono';
      return;
    }
    if (this.newPassword && this.newPassword2 && !this.checkParametriPassword()) {
      this.errMsg = 'La password non soddifa i requisiti richiesti';
      return;
    }
    
    const newPwdModel = new AggiornaPasswordModel();
    newPwdModel.username = this.username;
    newPwdModel.newPassword = this.newPassword;
    this.ilDatoNewPasswordEventEmitter.emit(newPwdModel);
    
  }

  checkParametriPassword(): boolean {
    if (
      this.newPassword.length < this.parametriPasswords.lunghezzaMinimaPassword
    ) {
      console.log('Lunghezza minima della password non rispettata');
      return false;
    }
    if (
      this.parametriPasswords.minimoMaiuscolePassword > 0 &&
      this.contaMaiuscole(this.newPassword) <
        this.parametriPasswords.minimoMaiuscolePassword
    ) {
      console.log('Numero minimo di maiuscole non rispettato');
      return false;
    }
    if (
      this.parametriPasswords.minimoMinuscolePassword > 0 &&
      this.contaMinuscole(this.newPassword) <
        this.parametriPasswords.minimoMinuscolePassword
    ) {
      console.log('Numero minimo di minuscole non rispettato');
      return false;
    }
    if (
      this.parametriPasswords.minimoNumeriPassword > 0 &&
      this.contaNumeri(this.newPassword) <
        this.parametriPasswords.minimoNumeriPassword
    ) {
      console.log('Numero minimo di numeri non rispettato');
      return false;
    }
    if (
      this.parametriPasswords.minimoCaratteriSpecialiPassword > 0 &&
      this.contaCaratteriSpeciali(this.newPassword) <
        this.parametriPasswords.minimoCaratteriSpecialiPassword
    ) {
      console.log('Numero minimo di caratteri speciali non rispettato');
      return false;
    }
    return true;
  }

  contaMaiuscole(input: string): number {
    const match = input.match(/[A-Z]/g);
    return match ? match.length : 0;
  }

  contaMinuscole(input: string): number {
    const match = input.match(/[a-z]/g);
    return match ? match.length : 0;
  }

  contaNumeri(input: string): number {
    const match = input.match(/\d/g);
    return match ? match.length : 0;
  }

  contaCaratteriSpeciali(input: string): number {
    const match = input.match(/[^a-zA-Z0-9\s]/g);
    return match ? match.length : 0;
  }
}
